
const servicesSwiper = new Swiper("[data-swiper-services-3]", {
  slidesPerView: 1, // Default slides per view
  spaceBetween:30, // Space between slides
  loop: true,
   navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    // When window width is >= 768px (desktop)
    991: {
      slidesPerView: 4,
       spaceBetween:10,
    },
     768: {
      slidesPerView: 1,
    },
  },
});
const collSwiper = new Swiper("[data-swiper-coll-3]", {
  slidesPerView: 2, // Default slides per view
  spaceBetween:15, // Space between slides
  loop: true,
   navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    // When window width is >= 768px (desktop)
    991: {
      slidesPerView: 4,
       spaceBetween:50,
    },
     768: {
      slidesPerView: 2,
    },
  },
});
document.addEventListener("DOMContentLoaded", function () {
  $('.main-media-container').slick({
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: true,
    dots: false,
    asNavFor: '.main-media-container-thumbs',
    prevArrow: $('.swiper-button-prev'),
    nextArrow: $('.swiper-button-next')
 });
  $('.main-media-container-thumbs').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.main-media-container',
    dots: false,
    focusOnSelect: true,
    variableWidth: true
  });
  // Remove active class from all thumbnail slides
  $('.main-media-container-thumbs .slick-slide').removeClass('slick-active');
  // Set active class to first thumbnail slides
  $('.main-media-container-thumbs .slick-slide').eq(0).addClass('slick-active');
  // On before slide change match active thumbnail to current slide
  $('.main-media-container').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
  var mySlideNumber = nextSlide;
  $('.main-media-container-thumbs .slick-slide').removeClass('slick-active');
  $('.main-media-container-thumbs .slick-slide').eq(mySlideNumber).addClass('slick-active');
});

    
 

  $('[data-fancybox="gallery"]').fancybox({
    arrows: true,
    keyboard: true,
    infobar: false,
    toolbar: true,
    buttons: ["zoom", "fullScreen", "close"],
  });
});
$( document ).ready(function() {
  
   $(".featured_products_container").slick({
   infinite: true,
    speed: 500,
     centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
     ariableWidth: true,
    dots: false,
     arrows:false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }); 
    $(".product-list").slick({
   infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }); 
});

